import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'MACHGO',
    description: "MACHGO is a private aviation house. Private jet flights planned around your schedule, your privacy and your comfort, to anywhere in the world.",
    placeholder: '',
    url: getOrigin(),
    ogImage: 'https://aerive.cdn.modulify.website/images/share/aerive-share.jpg'
}
